import request from '@/utils/request'
const baseURL = process.env.VUE_APP_BASE_API

export const ISSUESAPI = {
  // 获取主讲直播间列表
  getRooms: () => {
    return request({
      url: baseURL + 'master/rooms/tree',
      method: 'get'
    })
  },
  // 获取主讲直播时间段
  getRoomTimes: () => {
    return request({
      url: baseURL + 'master/time_range',
      method: 'get'
    })
  },
  // 获取主讲问题类型
  getIssueType: (params: string) => {
    return request({
      url: baseURL + 'master/issue_type?live_type_id=' + params,
      method: 'get'
    })
  },
  // 主讲工单创建
  addIssue: (data: object) => {
    return request({
      url: baseURL + 'master/ticket/add',
      method: 'post',
      data
    })
  },
  // 主讲工单编辑
  editIssue: (data: object) => {
    return request({
      url: baseURL + 'master/ticket/edit',
      method: 'post',
      data
    })
  },

  // 班主任工单创建
  addTutor: (data: object, params: any) => {
    return request({
      url: baseURL + 'assistant/ticket/add',
      method: 'post',
      data,
      params
    })
  },
  // 班主任工单编辑
  editTutor: (data: object) => {
    return request({
      url: baseURL + 'assistant/ticket/edit',
      method: 'post',
      data
    })
  },
  // 班主任工单重新编辑
  reEditTutor: (data: object, params: any) => {
    return request({
      url: baseURL + 'assistant/ticket/re-edit',
      method: 'post',
      data,
      params
    })
  },

  // LP工单创建
  addLP: (data: object) => {
    return request({
      url: baseURL + 'lp/ticket/add',
      method: 'post',
      data
    })
  },
  // LP工单编辑
  editLP: (data: object) => {
    return request({
      url: baseURL + 'lp/ticket/edit',
      method: 'post',
      data
    })
  },
  // LP工单重新编辑
  reEditLP: (data: object) => {
    return request({
      url: baseURL + 'lp/ticket/re-edit',
      method: 'post',
      data
    })
  }
}
